import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.freeze";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { H5_ID } from '@/utils/const';
export function trim(str) {
  return !str ? '' : str.replace(/(^\s*)|(\s*$)|( )/g, '');
}
export function getUrlParams() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href.split('?')[1] || '';
  // console.log(str);
  var pattern = /([^/?&=]+)=([^/#?&=]*)/gi,
      params = {}; // 定义正则表达式和一个空对象

  str.replace(pattern, function (a, b, c) {
    params[trim(b)] = decodeURIComponent(trim(c));
    return '';
  });
  return params;
}

function toQueryPair(key, value) {
  if (typeof value === 'undefined') {
    return key;
  }

  return "".concat(key, "=").concat(encodeURIComponent(value === null ? '' : String(value)));
}

export function freeze(obj) {
  return Object.freeze ? Object.freeze(obj) : obj;
}
export function toQueryString(params) {
  var ret = [];

  for (var key in params) {
    key = encodeURIComponent(key);
    var values = params[key];

    if (values && values.constructor === Array) {
      // 数组
      var queryValues = [];

      for (var i = 0, len = values.length, value; i < len; i++) {
        value = values[i];
        queryValues.push(toQueryPair(key, value));
      }

      ret = ret.concat(queryValues);
    } else {
      // 字符串
      ret.push(toQueryPair(key, values));
    }
  }

  return ret.join('&');
}
export function sleep(timeMill) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeMill);
  });
}
export function waitDomEvent(sprite) {
  var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'transitionend';
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;
  var canBubbles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return new Promise(function (resolve) {
    var onAnimationEnd = function onAnimationEnd(event) {
      if (!canBubbles && event.target !== sprite) {
        return;
      } // console.log('sprite onAnimationEnd');


      sprite.removeEventListener(eventName, onAnimationEnd);
      clearTimeout(time);
      resolve(event);
    };

    var time = setTimeout(function () {
      sprite.removeEventListener(eventName, onAnimationEnd);
      console.warn("watiDomEvent dom:".concat(sprite, " for event ").concat(event, " timeout of ").concat(timeout, "ms"));
      resolve();
    }, timeout); // console.log(`add event ${event}`);

    sprite.addEventListener(eventName, onAnimationEnd);
  });
}
export function waitComponentEvent(component, eventName) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;
  return new Promise(function (resolve) {
    var time = setTimeout(function () {
      console.warn("waitComponentEvent component:".concat(component, " timeout of ").concat(timeout, "ms"));
      resolve();
    }, timeout);

    var onAnimationEnd = function onAnimationEnd(event) {
      // console.log('sprite onAnimationEnd');
      clearTimeout(time);
      resolve(event);
    }; // console.log(`add event ${event}`);


    component.$once(eventName, onAnimationEnd);
  });
}
export function isResultOk(result) {
  return result.code === 0;
}
export function getResponseData(_ref) {
  var data = _ref.data;
  return data;
}
export function loadImage(_x) {
  return _loadImage.apply(this, arguments);
}

function _loadImage() {
  _loadImage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var image = new Image();
              image.src = url;
              image.onload = resolve;
              image.onerror = reject;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadImage.apply(this, arguments);
}

export function localStorageGetItem(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!window.localStorage) {
    return;
  }

  return JSON.parse(localStorage.getItem("".concat(H5_ID, "_").concat(key)) || defaultValue);
}
export function localStorageSetItem(key, value) {
  if (!window.localStorage) {
    return;
  }

  return localStorage.setItem("".concat(H5_ID, "_").concat(key), JSON.stringify(value));
}
export function localStorageRemoveItem(key) {
  if (!window.localStorage) {
    return;
  }

  return localStorage.removeItem("".concat(H5_ID, "_").concat(key));
}
/**
 * 乱序
 * @param array
 */

export function shuffle(array) {
  var currentIndex = array.length,
      temporaryValue,
      randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}
export function waitPageShow() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000 * 10;
  return new Promise(function (resolve, reject) {
    var listener = function listener() {
      if (document.visibilityState === 'visible') {
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', listener);
        resolve();
      }
    };

    var timer;

    if (timeout > 0) {
      var callReject = function callReject() {
        document.removeEventListener('visibilitychange', listener);
        reject(new Error('waitPageShow 超时' + timeout));
      };

      timer = window.setTimeout(callReject, timeout);
    }

    document.addEventListener('visibilitychange', listener);
  });
}
export function getBackgroundImageVal(url) {
  if (!url) {
    return '';
  }

  return "url(".concat(url, ")");
} //支持地址编码、出生日期、校验位验证

export function checkIdCard(code) {
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  var pass = true;

  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    pass = false;
  } // @ts-ignore


  if (!city[code.substr(0, 2)]) {
    pass = false;
  }

  if (code.length == 18) {
    var sBirthday = code.substr(6, 4) + "-" + Number(code.substr(10, 2)) + "-" + Number(code.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));

    if (sBirthday != d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()) {
      pass = false;
    }
  } //18位身份证需要验证最后一位校验位


  if (code.length == 18) {
    var aryCode = code.split(''); //加权因子

    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //校验位

    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    var ai = '';
    var wi = 0;

    for (var i = 0; i < 17; i++) {
      ai = aryCode[i];
      wi = factor[i];
      sum += +ai * wi;
    }

    var last = parity[sum % 11];

    if (parity[sum % 11] != aryCode[17]) {
      pass = false;
    }
  }

  return pass;
}